<template>
    <session class="mobile-page-register" :class="{ ffen: getLocalLangCode() != 'zh' }">
        <Header />
        <div class="register-form-block">
            <div class="register-form-block-header">
                <div v-for="(item) in entrancesList">
                    <div v-if="item.id === customerType">
                        <p class="title">{{ item.title }}</p>
                        <p class="subtext">{{ item.desc }}</p>
                    </div>
                </div>
            </div>
            <div class="register-block-l" v-if="step == 1">
                <div class="register-block-title">{{LOCAL('register_title')}}</div>
                <div class="register-block-info-wrapper">
                    <div class="register-block-info-menu"><span class="required">*</span>{{LOCAL('register_account')}}</div>
                    <div class="register-block-info-input">
                        <input type="text" v-model="username" @blur="checkUsername" @input="nocheckUsername" maxlength="20" :placeholder="LOCAL('placeholder_common')" autofocus>
                        <div class="register-block-info-tip" :class="{error: errorUsername}">
                            <span v-if="!correctUsername">{{LOCAL('register_account_tip')}}</span>
                        </div>
                    </div>
                </div>
                <div class="register-block-info-wrapper">
                    <div class="register-block-info-menu"><span class="required">*</span>{{LOCAL('register_email')}}</div>
                    <div class="register-block-info-input">
                        <input type="text" v-model="email" @blur="validateEmail" @input="nocheckEmail" :placeholder="LOCAL('placeholder_common')">

                    <div class="register-block-info-tip" :class="{error: errorEmail}"><span v-if="!correctEmail">{{LOCAL('register_email_tip')}}</span></div>
                    </div>
                </div>
                <div class="register-block-info-wrapper">
                    <div class="register-block-info-menu"><span class="required">*</span>{{LOCAL('register_password')}}</div>
                    <div class="register-block-info-input">
                        <input :type="showPassword ? 'text' : 'password'" v-model="password" @input="showVisible" @blur="validatePassword" maxlength="20" :placeholder="LOCAL('placeholder_common')"/>
                        <Icon v-if="startInput" :name="showPassword ? 'pass_0' : 'pass_1'" name="visible" size="24" @click="viewPassword" class="icon-visible"/>
                    <div class="register-block-info-tip" :class="{error: errorPassword}"><span v-if="!correctPassword" v-html="LOCAL('register_password_tip_mobile')"></span>
                    </div>

                </div>
                </div>
                <div class="register-block-info-wrapper">
                    <div class="register-block-info-menu"><span class="required">*</span>{{LOCAL('register_password_again')}}</div>
                    <div class="register-block-info-input">
                        <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword" @input="showConfirmVisible" @blur="validateConfirmPassword" maxlength="20" :placeholder="LOCAL('placeholder_common')">
                        <Icon v-if="startInputConfirm"  :name="showConfirmPassword ? 'pass_0' : 'pass_1'" size="24" @click="viewConfirmPassword" class="icon-visible"/>
                        <div class="register-block-info-tip" v-if="!correctConfirmPassword" :class="{error: errorConfirmPassword}">{{LOCAL('register_password_again_error')}}</div>
                    </div>
                        
                </div>
                <div class="register-block-info-wrapper">
                    <div class="register-block-info-menu"><span class="required">*</span>{{LOCAL('register_promo_code')}}</div>
                    <div class="register-block-info-input">
                        <input type="text" v-model="promoCode" @input="checkPromoCode" maxlength="10" :placeholder="LOCAL('placeholder_common')">
                        <div class="register-block-info-tip" v-if="errorPromoCode" :class="{error: errorPromoCode}">{{LOCAL('register_promo_code_error')}}</div>
                    </div>
                </div>
                <div class="register-block-btn-group">
                    <div class="register-block-btn-cancel" @click="goBack">{{ LOCAL('register_cancel_btn') }}</div>
                    <button class="register-block-btn-next" :class="{active: correctUsername && correctEmail && correctPassword && correctConfirmPassword && hasPromoCode}" @click="validatePromoCode" :disabled="errorUsername || errorEmail || errorPassword || errorConfirmPassword || errorPromoCode || !hasPromoCode ">{{ LOCAL('next') }}</button>
                </div>
            </div>

        </div>
        <Footer />
    </session>
</template>

<script setup>
    import { ref, onMounted,watchEffect } from 'vue';
    import * as Utils from '@/assets/utils';
    import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
    import Icon from '@/components/icon/index.vue';
    import router from '@/router';
    import Header from '@/mobile/components/header/index.vue';
    import Footer from '@/mobile/components/footer/index.vue';
    import { useRoute } from 'vue-router'


    const route = useRoute();
    let customerType = ref(route.query.plan)
    // 流出步骤
    const step = ref(1);  // 1 - 第一步；2 - 第二步
    // 入口列表

    const entrancesList = [
        { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person', id: 'person' },
        { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise', id: 'enterprise' },
        { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent', id: 'agent' },
    ]


const username = ref('');
let errorUsername = ref(false);
let correctUsername = ref(false)

const email = ref('');
let errorEmail = ref(false);
let correctEmail = ref(false)

const password = ref('')
let startInput = ref(false)
let showPassword = ref(false)
let errorPassword = ref(false)
let correctPassword = ref(false)

const confirmPassword = ref('')
let startInputConfirm = ref(false)
let showConfirmPassword = ref(false)
let correctConfirmPassword = ref(false)
let isReset = ref(false)
let errorConfirmPassword = ref(false)

const promoCode = ref('')
let hasPromoCode = ref(false)
let errorPromoCode = ref(false)


const checkUsername = () => {
    if (!/^[\w]{3,20}$/.test(username.value)) {
        errorUsername.value = true
        correctUsername.value = false
    } else {
        errorUsername.value = false
        correctUsername.value = true
    }
}

const nocheckUsername = () => {
    errorUsername.value = false
}

const validateEmail = () => {
    if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email.value)) {
        errorEmail.value = true
        correctEmail.value = false
    } else {
        errorEmail.value = false
        correctEmail.value = true
    }
}

const nocheckEmail = () => {
    errorEmail.value = false
}

const showVisible = (e) => {
    if(e.target.value.length > 0){
        startInput.value = true
    } else {
        startInput.value = false
        showPassword.value  = false
    }
    confirmPassword.value = ''
    isReset.value = true
    errorPassword.value = false
}

const showConfirmVisible = (e) => {
    if(e.target.value.length > 0){
        startInputConfirm.value = true
    } else {
        startInputConfirm.value = false
        showConfirmPassword.value = false
    }
    errorConfirmPassword.value = false
}

const viewPassword = () => {
    showPassword.value = !showPassword.value
}

const viewConfirmPassword = () => {
    showConfirmPassword.value = !showConfirmPassword.value
}

const validatePassword = () => {
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{7,}$/.test(password.value)) {
        errorPassword.value = true
        correctPassword.value = false
    } else {
        errorPassword.value = false
        correctPassword.value = true
    }
    
}

const validateConfirmPassword = () => {
    isReset.value = false
    if(correctPassword.value){
        if (password.value !== confirmPassword.value) {
            errorConfirmPassword.value = true
            correctConfirmPassword.value = false
        } else {
            errorConfirmPassword.value = false
            correctConfirmPassword.value = true
        }
    }
    
}

const checkPromoCode = (e) => {
    if(e.target.value.length > 0){
        hasPromoCode.value = true
        errorPromoCode.value = false
    } else {
        hasPromoCode.value = false
    }
}

const validatePromoCode = () => {
    errorPromoCode.value = true
    hasPromoCode.value = false
}

const goBack = () => {
    router.go(-1)
}

// 监听路由变化并更新message
watchEffect(() => {
    customerType = route.query.plan;
});

onMounted(()=> {
    step.value = 1;
    if (!route.query.plan){
        router.replace(
      { 
        path: '/register', 
        query: {
          plan: 'person'
        }  
      });
    }
})

</script>

<style scoped lang="less">
  @import "index.less";
</style>
